import type { TransferRequest } from '@fruitful/types';
import { atom } from 'jotai';

export const transferRequestAtom = atom<TransferRequest | null>(null);
export const preselectedTransferAccountsAtom = atom<{
    toSyncteraAccountId?: string;
    fromSyncteraAccountId?: string;
} | null>(null);
